import React from 'react';

const YouTubeLogoIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    version='1.1'
    {...props}
    viewBox='0 0 256 256'
    xmlSpace='preserve'>
    <defs></defs>
    <g
      style={{
        stroke: 'none',
        strokeWidth: '0',
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: '10',
        fill: 'none',
        fillRule: 'nonzero',
        opacity: '1',
      }}
      transform='translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)'>
      <circle
        cx='45'
        cy='45'
        r='45'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(254,0,1)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform='matrix(1 0 0 1 0 0) '
      />
      <path
        d='M 41.988 37.316 c -0.646 -0.436 -1.105 -1.113 -1.378 -2.031 c -0.273 -0.918 -0.409 -2.14 -0.409 -3.666 v -2.078 c 0 -1.541 0.155 -2.779 0.467 -3.712 c 0.311 -0.934 0.798 -1.615 1.459 -2.043 c 0.661 -0.428 1.529 -0.642 2.603 -0.642 c 1.058 0 1.907 0.218 2.545 0.654 c 0.638 0.436 1.105 1.117 1.401 2.043 c 0.296 0.926 0.444 2.16 0.444 3.701 v 2.078 c 0 1.526 -0.144 2.751 -0.432 3.677 c -0.288 0.926 -0.755 1.603 -1.401 2.031 c -0.646 0.428 -1.522 0.642 -2.627 0.642 C 43.525 37.969 42.633 37.751 41.988 37.316 z M 45.607 35.074 c 0.179 -0.467 0.268 -1.229 0.268 -2.288 v -4.46 c 0 -1.027 -0.09 -1.778 -0.268 -2.253 c -0.179 -0.475 -0.494 -0.712 -0.946 -0.712 c -0.436 0 -0.743 0.238 -0.922 0.712 c -0.179 0.475 -0.268 1.226 -0.268 2.253 v 4.46 c 0 1.059 0.085 1.821 0.257 2.288 c 0.171 0.467 0.482 0.7 0.934 0.7 C 45.112 35.775 45.428 35.541 45.607 35.074 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(255,255,255)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform='matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 34.142 31.385 l -3.666 -13.238 h 3.199 l 1.284 6.001 c 0.327 1.479 0.568 2.74 0.724 3.782 h 0.093 c 0.109 -0.747 0.35 -2 0.724 -3.759 l 1.331 -6.024 h 3.199 l -3.712 13.238 v 6.351 h -3.175 V 31.385 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(255,255,255)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 59.524 23.423 v 14.312 h -2.522 l -0.28 -1.751 h -0.07 c -0.685 1.323 -1.713 1.985 -3.082 1.985 c -0.95 0 -1.65 -0.311 -2.101 -0.934 c -0.452 -0.622 -0.677 -1.595 -0.677 -2.919 V 23.423 h 3.222 V 33.93 c 0 0.638 0.07 1.094 0.21 1.366 c 0.14 0.273 0.374 0.409 0.7 0.409 c 0.28 0 0.549 -0.085 0.806 -0.257 c 0.257 -0.171 0.447 -0.389 0.572 -0.654 v -11.37 H 59.524 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(255,255,255)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 65.245 71.854 h -40.49 c -4.295 0 -7.776 -3.482 -7.776 -7.776 V 50.913 c 0 -4.295 3.482 -7.776 7.776 -7.776 h 40.49 c 4.295 0 7.776 3.482 7.776 7.776 v 13.164 C 73.021 68.372 69.54 71.854 65.245 71.854 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(255,255,255)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 58.727 61.452 v 0.724 c 0 0.919 0.027 1.607 0.082 2.066 c 0.054 0.459 0.167 0.794 0.339 1.004 c 0.171 0.21 0.435 0.315 0.794 0.315 c 0.482 0 0.813 -0.187 0.992 -0.56 c 0.179 -0.374 0.276 -0.996 0.292 -1.868 l 2.778 0.163 c 0.015 0.125 0.023 0.296 0.023 0.514 c 0 1.323 -0.362 2.312 -1.086 2.965 c -0.724 0.654 -1.747 0.981 -3.07 0.981 c -1.588 0 -2.701 -0.498 -3.339 -1.494 c -0.638 -0.996 -0.957 -2.537 -0.957 -4.623 V 59.14 c 0 -2.148 0.331 -3.716 0.992 -4.705 c 0.661 -0.988 1.794 -1.483 3.397 -1.483 c 1.105 0 1.953 0.203 2.545 0.607 c 0.591 0.405 1.008 1.035 1.249 1.891 C 64 56.308 64.121 57.491 64.121 59 v 2.452 H 58.727 z M 59.136 55.428 c -0.163 0.202 -0.272 0.533 -0.327 0.992 c -0.055 0.459 -0.082 1.156 -0.082 2.09 v 1.027 h 2.358 V 58.51 c 0 -0.918 -0.031 -1.615 -0.093 -2.09 c -0.062 -0.475 -0.175 -0.809 -0.339 -1.004 c -0.164 -0.195 -0.417 -0.292 -0.759 -0.292 C 59.552 55.125 59.299 55.226 59.136 55.428 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(254,0,1)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 43.2 53.223 v 14.312 h -2.522 l -0.28 -1.751 h -0.07 c -0.685 1.323 -1.713 1.985 -3.082 1.985 c -0.95 0 -1.65 -0.311 -2.101 -0.934 c -0.452 -0.622 -0.677 -1.595 -0.677 -2.919 V 53.223 h 3.222 v 10.507 c 0 0.638 0.07 1.094 0.21 1.366 c 0.14 0.273 0.374 0.409 0.7 0.409 c 0.28 0 0.549 -0.085 0.806 -0.257 c 0.257 -0.171 0.447 -0.389 0.572 -0.654 v -11.37 H 43.2 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(254,0,1)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 35.429 50.538 H 32.23 v 16.997 h -3.152 V 50.538 h -3.199 v -2.592 h 9.549 V 50.538 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(254,0,1)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
      <path
        d='M 53.864 55.511 c -0.195 -0.903 -0.51 -1.556 -0.946 -1.961 c -0.436 -0.405 -1.035 -0.607 -1.798 -0.607 c -0.592 0 -1.144 0.167 -1.658 0.502 c -0.514 0.335 -0.911 0.775 -1.191 1.319 h -0.024 l 0 -7.542 h -3.105 v 20.313 h 2.662 l 0.327 -1.354 h 0.07 c 0.249 0.483 0.622 0.864 1.121 1.144 c 0.498 0.28 1.051 0.42 1.658 0.42 c 1.089 0 1.891 -0.502 2.405 -1.506 c 0.514 -1.004 0.771 -2.572 0.771 -4.705 V 59.27 C 54.156 57.667 54.058 56.414 53.864 55.511 z M 50.911 61.349 c 0 1.043 -0.043 1.86 -0.128 2.451 c -0.086 0.592 -0.23 1.012 -0.432 1.261 c -0.202 0.249 -0.475 0.374 -0.817 0.374 c -0.265 0 -0.51 -0.062 -0.735 -0.187 c -0.226 -0.124 -0.409 -0.311 -0.549 -0.56 v -8.125 c 0.109 -0.389 0.295 -0.708 0.56 -0.957 c 0.264 -0.249 0.552 -0.374 0.864 -0.374 c 0.327 0 0.58 0.128 0.759 0.385 c 0.179 0.257 0.303 0.689 0.374 1.296 c 0.07 0.607 0.105 1.471 0.105 2.592 V 61.349 z'
        style={{
          stroke: 'none',
          strokeWidth: '1',
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: '10',
          fill: 'rgb(254,0,1)',
          fillRule: 'nonzero',
          opacity: '1',
        }}
        transform=' matrix(1 0 0 1 0 0) '
        strokeLinecap='round'
      />
    </g>
  </svg>
);

export default YouTubeLogoIcon;
